import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

const AvatarLink = styled(({ banned, children, ...rest }) => (
  <Link {...rest}>{children}</Link>
))`
  text-decoration: none;
  opacity: ${props => (props.banned ? '0.5' : '1')};
`;

export default AvatarLink;
